export type AgreementAlertType = 'expired' | 'atp-status' | 'expiring-soon';

interface AgreementAlertContext {
  isExpired: boolean;
  isExpiring: boolean;
  isEnabled: boolean;
  showAtpStatusAlert: boolean;
}

export default function getAgreementAlertType({
  isExpired,
  isExpiring,
  isEnabled,
  showAtpStatusAlert,
}: AgreementAlertContext): AgreementAlertType | null {
  if (isExpired) return 'expired';

  if (showAtpStatusAlert) return 'atp-status';

  if (isEnabled && isExpiring) return 'expiring-soon';

  return null;
}
